import React, { useCallback } from "react";
import { PaginatedEntityTable } from "components/common";
import { fetchDataLakeRetrievals, keyFn } from "./useDataLakeRetrievals";
import customColumnRenderers from "./list-components/customColumnRenderers";
import DataLakeRetrievalActions from "./DataLakeRetrievalActions";
export const DEFAULT_DISPLAYED_ATTRIBUTES = [
  "retrieved_at",
  "source_name",
  "status",
  "timestamp_from",
  "timestamp_to",
  "retrieved_documents",
  "stream_title",
  "index_failures",
  "restore_indices"
];
export const DEFAULT_LAYOUT = {
  entityTableId: "retrievals",
  defaultPageSize: 20,
  defaultSort: { attributeId: "retrieved_at", direction: "desc" },
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES
};
const DataLakeRetrievalsList = () => {
  const retrievalActions = useCallback(
    (retrieval) => /* @__PURE__ */ React.createElement(DataLakeRetrievalActions, { retrieval }),
    []
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "retrievals",
      entityActions: retrievalActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchDataLakeRetrievals,
      keyFn,
      columnRenderers: customColumnRenderers,
      entityAttributesAreCamelCase: false,
      searchPlaceholder: "Search for retrieval",
      fetchOptions: { refetchInterval: 5e3 }
    }
  );
};
export default DataLakeRetrievalsList;
